<template>
  <div class="home-widget col-sm-12 col-md-12 col-lg-4">
    <spinner-loader v-if="loading" :height="280"/>
    <div class="widget-body" v-else>
      <p class="widget-title"><font-awesome-icon icon="file-alt" /> Your last Reports:</p>
      <render-index-table :reports="$store.state.reports.items" :fields="fields" />
    </div>
  </div>
</template>

<script>
  import RenderIndexTable from '../../views/reports/RenderIndexTable.vue';
  import SpinnerLoader from '../Spinner-loader.vue';
  export default {
    components: {
      RenderIndexTable,
      SpinnerLoader
    },
    data() {
      return {
        fields: ['title', 'actions'],
        loading: true
      }
    },
    computed: {
      
    },
    beforeCreate() {
      this.$store.commit('reports/SET_PAGINATION_LIMIT', 5);
      this.$store.dispatch('reports/fetch').then(() => {
        this.loading = false;
        this.$store.commit('reports/SET_PAGINATION_LIMIT', 50);
      });
    }
  }
</script>
